import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexDirection: 'row',
    marginBottom: theme.spacing(-1),
  },
  noteWrapper: {
    width: '100%',
  },
}))
